(($) => {
  $("#categories-submit").hide();
  $("#cat").on("change", function () {
    $(this).closest("form").submit();
  });

  $(".add-to-cart-box__configurable select")
    .on("change", function () {
      const $opt = $(this).find("option:selected"),
        $addToCartContainer = $(this).closest(".add-to-cart-box__configurable"),
        label = $opt.data("label"),
        productId = $opt.data("productId"),
        statusText = $opt.data("statustext");

      $(`#product-availability-${productId}`)
        .find(".label")
        .replaceWith(`<span class="label ${label}">${statusText}</span>`);

      $addToCartContainer.find(":submit").attr("disabled", label === "label-danger");
    })
    .change();
})(jQuery);
